var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProbablyNo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#f37f7f;}.b{fill:#f37f7f;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176.924 -55.924)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(176.924 55.924)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 6.5,
    cy: 6.5,
    r: 6
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.056-3.008c.584-.767,1.178-1.525,1.762-2.3.584.777,1.19,1.535,1.785,2.3H7.365L4.694-6.476,7.23-9.828H5.535C4.974-9.08,4.4-8.342,3.829-7.6L2.123-9.828H.35c.864,1.137,1.728,2.273,2.6,3.4L.35-3.008Z",
    transform: "translate(179.759 68.922)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbablyNo);
export default __webpack_public_path__ + "static/media/probably_no.388c4be6c6a2506a0e1b48d11b2fd9e4.svg";
export { ForwardRef as ReactComponent };